/* eslint-disable radix */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-console */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  MainContainer, Paragraph, Image, Button,
} from './StyledComponents';
import logo from '../images/icon-192x192.png';
import profile from '../images/profile.png';
import loader from '../images/loading.gif';
import logging from '../services/base64conversion';
import userInfoObjectCreator from '../services/userInfoObjectCreator';

export default class StudentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studentDetails: [],
      loading: true,
    };
    this.getSuffix = this.getSuffix.bind(this);
  }

  async componentDidMount() {
    // Getting details of student and redirecting request accordingly
    const studentDetails = JSON.parse(localStorage.getItem('studentDetails'));
    const qrData = JSON.parse(localStorage.getItem('qrData'));
    const header = logging();
    if (studentDetails && qrData) {
      this.setState({
        studentDetails,
        loading: false,
      });
      await fetch(process.env.REACT_APP_API_QR_DATA, {
        method: 'POST',
        body: JSON.stringify(qrData),
        headers: {
          Authorization: header,
        },
      })
        .then(() => {
           // console.log('Saved to Cache');
        })
        // .catch((err) =>  // console.log(err));
    } else {
      await fetch(process.env.REACT_APP_API_QR_DATA)
        .then((response) => response.json())
        .then((data) => {
          if (data.hasOwnProperty('school_name')) {
            return data;
          }
          return [];
        })
        .then((datas) => {
          if (datas.hasOwnProperty('school_name')) {
            const userInfo = userInfoObjectCreator(datas);
            this.setState({
              studentDetails: userInfo,
              loading: false,
            });
            localStorage.setItem('studentDetails', JSON.stringify(userInfo));
            localStorage.setItem('qrData', JSON.stringify(datas));
          } else {
            const { history } = this.props;
            history.replace('/');
          }
        })
        .catch((err) => {
          const { history } = this.props;
          history.replace('/');
           // console.log(err);
        });
    }
  }

  getSuffix() {
    const { studentDetails } = this.state;
    const j = studentDetails.grade % 10;
    const k = studentDetails.grade % 100;
    if (j === 1 && k !== 11) {
      return `${studentDetails.grade}st`;
    }
    if (j === 2 && k !== 12) {
      return `${studentDetails.grade}nd`;
    }
    if (j === 3 && k !== 13) {
      return `${studentDetails.grade}rd`;
    }
    return `${studentDetails.grade}th`;
  }

  render() {
    const {
      studentDetails,
      loading,
    } = this.state;
    const { history } = this.props;

    if (loading) {
      return (
        <MainContainer className="student-detail-page">
          <img src={loader} alt="Loading ..." />
        </MainContainer>
      );
    }

    if (studentDetails.student_photo_url === '' || studentDetails.student_photo_url === ' ') {
      history.push({
        pathname: '/noAccess',
        state: {
          isStudentInActive: false,
        },
      });
      return 0;
    }

    return (
      <MainContainer className="student-detail-page">
        <header>
          <div
            className="settings-btn"
            role="button"
            tabIndex={0}
            onKeyPress={() => {}}
          >
            <span><i className="fa fa-cog" aria-hidden="true" /></span>
          </div>
          <Paragraph className="school-name">
            {studentDetails.school_name}
          </Paragraph>
          <div
            role="button"
            className="options-btn"
            tabIndex={0}
            onKeyPress={() => {}}
          >
            <span><i className="fa fa-ellipsis-h" aria-hidden="true" /></span>
          </div>
        </header>

        <div className="student-photo-wrapper">
          <div className="student-photo">
            <Image
              alt="Student"
              src={studentDetails.student_photo_url || profile}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = profile;
              }}
              className="student-img"
            />
          </div>
          <div className="school-logo">
            <Image
              alt="School Logo"
              src={studentDetails.school_logo || logo}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = logo;
              }}
              className="school-img"
            />
          </div>
        </div>

        <Paragraph className="stu-name">
          {studentDetails.first_name}
          {' '}
          {studentDetails.last_name}
        </Paragraph>
        <Paragraph className="stu-grade">
          {this.getSuffix()}
          {' '}
          Grade
        </Paragraph>
        <div className="btns-grp">
          <Button
            onClick={() => {
              history.push('/comingSoon');
            }}
          >
            My Inbox (0)
          </Button>
          <Button
            onClick={() => {
              history.push('/studentID');
            }}
          >
            Student ID
          </Button>
          <Button
            onClick={() => {
              history.push('/studentSchedule');
            }}
          >
            My Schedule
          </Button>
          <Button
            onClick={() => {
              history.push('/comingSoon');
            }}
          >
            New Tutoring Request
          </Button>
          <Button
            onClick={() => {
              history.push('/comingSoon');
            }}
          >
            My Reward Points
          </Button>
          <Button
            onClick={() => {
              history.push('/comingSoon');
            }}
          >
            New Counselor Request
          </Button>
          <Button
            onClick={() => {
              history.push('/comingSoon');
            }}
          >
            Ask a Question
          </Button>
          <Button
            className="btn-more"
          >
            More...
          </Button>
        </div>
      </MainContainer>
    );
  }
}
StudentDetails.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
};
